import { yyyymmddToDate } from "./Shared";

export default class ParkSite {
  public parkName = "";
  public displayName = "";

  public address = "";
  public school = "";

  public creator = "";
  public creationDate = "";
  public modifier = "";
  public modifiedDate = "";

  public centerLatitude = 0;
  public centerLongitude = 0;
  public parkRadius = 15;
  public overrideAccuracy = 0;
  public isTestPark = false;
  public isActive = false;
  public disableFence = false;
  public country = "NZ";
  public excludedWorlds: string[] = [];
  public DISPLAY_NAME?: string = "";

  public newCouncil: string | undefined;
  public council: string | undefined; //A link to client now

  public fromDate: string | undefined;
  public toDate: string | undefined;

  public openHour: string | undefined;
  public closedHour: string | undefined;

  public message: string | undefined;
  public hs: string | undefined;

  public wifiname: string | undefined;
  public wifipass: string | undefined;
  public wifiinfo: string | undefined;
}

export function isPublicPark(park: ParkSite) {

  return !park.isTestPark && !isDisabled(park);

}

export function isDisabled(park: ParkSite): boolean {

  const now = (new Date());
  now.setHours(0, 0, 0, 0);

  //Maybe the park hasn't opened yet
  if (park.fromDate) {
    const fromDate = yyyymmddToDate(park.fromDate);
    if (now < fromDate) {
      return true;
    }
  }

  //Maybe the park is now closed
  if (park.toDate) {
    const toDate = yyyymmddToDate(park.toDate);
    if (toDate < now) {
      return true;
    }
  }

  //If we get to here, just use the "is active" flag
  return !park.isActive;

}

export function getDistanceToParkSite(ParkSite: ParkSite, lat: number, lon: number) {

  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad(ParkSite.centerLatitude - lat);  // deg2rad below
  const dLon = deg2rad(ParkSite.centerLongitude - lon);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat)) * Math.cos(deg2rad(ParkSite.centerLatitude)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c; // Distance in km
  return d;

}

function deg2rad(deg: number) {
  return deg * (Math.PI / 180)
}

